import React, {Component} from "react"
import styles from "./Footer.module.css"

interface Props {}

export class Footer extends Component<Props, {}> {
    public render() {
        return (
            <footer className={styles.root}>
                <div className={styles.wrapper}>
                    <address className={styles.address}></address>
                    <p className={styles.text}>
                        <strong>The Salon Professional Academy</strong>
                    </p>
                    <div>
                        <p className={styles.text}>
                            THE PLACE WHERE YOU BECOME WHO YOU WERE MEANT TO BE
                        </p>
                        <p className={styles.text}>Let us help you explore your options.</p>
                    </div>
                </div>
            </footer>
        )
    }
}
